import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.REACT_APP_BASE_URL.split("/v1")[0];

export const socket = io(URL, { autoConnect: true });
